import { executeGet } from '../common/apiCaller'
import {
  GetPdfUrlInputDto,
  GetDownloadPdfUrlDto,
  GetBatchResultInputDto,
  GetBatchResultResponseDto,
} from '../dto/acceptNoticeDto'

const apiName = 'citizen'
const apiPath = '/accept-notice'

// 承諾通知書PDFダウンロードURL取得
export const executeGetDownloadPdfUrl = (input: GetPdfUrlInputDto) => {
  return executeGet<GetDownloadPdfUrlDto>(apiName, `${apiPath}/pdf-url`, input)
}

// バッチ処理結果取得
export const executeGetBatchResult = (input: GetBatchResultInputDto) => {
  return executeGet<GetBatchResultResponseDto[]>(apiName, `${apiPath}/batch-results`, input)
}
